module.exports = __webpack_public_path__ + "img/blue_check.991b41ce.svg";